"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOfTypeGracefulError = void 0;
exports.isOfTypeGracefulError = function (tbd) {
    if (tbd.message) {
        return true;
    }
    return false;
};
//# sourceMappingURL=GracefulError.js.map